import {
  ParameterTypeEnum,
  PlaceholderCategoryEnum,
  type PlaceholderReference,
  PlaceholderTypeEnum,
} from './types.ts';

export const staticPlaceholderReferences = [
  {
    code: '${customCode}',
    label: 'Funzione personalizzata',
    description:
      'Inserisci una stringa placeholder con funzione personalizzata',
    category: PlaceholderCategoryEnum.Funzione,
    parameters: [
      {
        id: 'customCode',
        type: ParameterTypeEnum.String,
        label: 'Stringa placeholder',
      },
    ],
    examples: ['$$fncDecode...$$'],
    type: PlaceholderTypeEnum.String,
  },
  {
    code: '$$page_number$$',
    label: 'Numero pagina',
    description: 'Numero della pagina corrente',
    category: PlaceholderCategoryEnum.Altro,
    parameters: [],
    examples: ['$$page_number$$'],
    type: PlaceholderTypeEnum.Html,
  },
  {
    code: '$$page_total$$',
    label: 'Numero totale pagine',
    description: 'Numero totale delle pagine',
    category: PlaceholderCategoryEnum.Altro,
    parameters: [],
    examples: ['$$page_total$$'],
    type: PlaceholderTypeEnum.Html,
  },
] as const satisfies PlaceholderReference[];

export type StaticPlaceholderReferences = typeof staticPlaceholderReferences;
export type StaticPlaceholderReferenceRecordKey =
  StaticPlaceholderReferences[number]['code'];
export type StaticPlaceholderReferenceRecord = Partial<
  Record<StaticPlaceholderReferenceRecordKey, string>
>;
